<template>
  <div class="activity-mobile">
    <div>
      <img src="~@/assets/img/activity/sign-banner-m.jpg" width="100%" alt="">
    </div>
    <div class="content-box">
      <van-form class="form" label-width="100%" ref="form" @submit="onSubmit">
        <div class="title" style="margin-bottom: 18px">参会人信息</div>
        <van-field
            v-model="form.userName"
            name="userName"
            label="姓名"
            required
            :maxlength="100"
            placeholder="请填写参会人的姓名"
            :rules="[
            { required: true, message: '不可为空' },
          ]"
        />
        <van-field
            v-model="form.userPosition"
            name="userPosition"
            label="职位"
            required
            :maxlength="100"
            placeholder="请填写参会人的职位"
            :rules="[
            { required: true, message: '不可为空' },
          ]"
        />
        <van-field
            v-model="form.phone"
            name="phone"
            label="联系电话"
            required
            :maxlength="11"
            placeholder="请填写参会人的电话"
            :rules="[
            { required: true, message: '不可为空' },
            { pattern: /^1[0-9]{10}$/,  message: '请输入合法的手机号码' }
          ]"
        />
        <div class="code-box">
          <van-field
              class="code-input"
              v-model="form.imgCaptcha"
              name="imgCaptcha"
              label="图形验证码"
              required
              :maxlength="4"
              placeholder="请填写图形验证码"
              :rules="[
              { required: true, message: '不可为空' },
              { validator:validatorCode, message: '验证码校验失败' },
            ]"
          >
            <template #button>
              <img class="code-img" :src="reflashVerifyCodeUrl" alt="图形验证码" @click="getVerification">
            </template>
          </van-field>
        </div>
        <van-field
            v-model="form.wechat"
            name="wechat"
            label="微信号"
            required
            :maxlength="100"
            placeholder="请填写参会人的微信"
            :rules="[
            { required: true, message: '不可为空' },
          ]"
        />
        <van-field
            v-model="form.email"
            name="email"
            label="电子邮箱"
            required
            :maxlength="50"
            placeholder="请填写参会人的电子邮箱"
            :rules="[
            { required: true, message: '不可为空' },
            { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,  message: '请输入正确的邮箱格式' },
          ]"
        />
        <van-field
            v-model="form.companyName"
            name="companyName"
            label="公司名称"
            required
            :maxlength="100"
            placeholder="请填写参会人的公司名称"
            :rules="[
            { required: true, message: '不可为空' },
          ]"
        />
        <div style="margin-top: 22px;">
          <van-button class="radius" block type="info" native-type="submit">提交报名</van-button>
        </div>
      </van-form>
      <div class="notice">
        <div class="title">报名须知</div>
        <div class="notice-content">
          1. 报名时间：2025年7月25日 - 2025年8月14日
          <br>
          2. 活动时间：2025年8月15日下午14:00-17:30
          <br>
          3. 活动地点：上海世博洲际酒店-二层-大宴会厅
          <br>
          4. 详细地址：上海浦东新区雪野路1188号
          <br>
          5. 请使用真实、准确、完整的个人信息进行报名；
          <br>
          6. 报名成功后，金标联盟客服将会添加您的微信发送邀请函，请留意添加好友信息;
          <br>
          7. 报名审核通过即确认席位，参会资格不可转让，如无法参加，无需取消；
          <br>
          8. 如有疑问请咨询官方客服微信：itgsakf
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {singleActivitySever} from "@/common/api-config";
export default {
  data() {
    return {
      form: {
        organizerActivityId: '',
        userName: '',
        userPosition: '',
        phone: '',
        imgCaptcha: '',
        wechat: '',
        email: '',
        companyName: '',
      },

      ckey: "",
      reflashVerifyCodeUrl: "",
    };
  },
  created() {
    if(this.$route.query.id){
      this.form.organizerActivityId=this.$route.query.id || '1';
    }
    this.getEnvironment();
  },
  mounted() {
    this.getVerification() // 获取验证码
    this.updateBoxWidth('auto')
  },
  beforeDestroy() {
    this.updateBoxWidth('1280px')
  },
  methods: {
    getEnvironment(){
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      // 如果屏幕宽度小于等于768px，则认为是移动端
      const deviceType = screenWidth <= 768 ? 'mobile' : 'pc';
      // 如果是PC端但访问的是移动端URL，则跳转到PC端URL
      if (deviceType === 'pc') {
        this.$router.replace({path: '/activity/web', query: {'id': this.$route.query.id}});
      }
    },
    // 动态修改外层盒子宽度
    updateBoxWidth(value) {
      const appBox = document.getElementsByClassName('appBox')
      if (appBox && appBox.length) {
        appBox[0].style.minWidth = value
      }
    },
    // 校验图形验证码
    validatorCode(val) {
      return new Promise((resolve) => {
        let loading = this.$toast.loading({
          duration: 0,
          overlay: true,
          forbidClick: true,
        });
        singleActivitySever.checkImgCaptcha({
          ckey: this.ckey,
          imgCaptcha: val,
        }).then(res => {
          loading.clear();
          if (res["code"] == 0) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
      });
    },
    // 获取图形验证码
    async getVerification() {
      singleActivitySever.getImgCaptcha().then(res => {
        if (res["code"] == 0) {
          this.reflashVerifyCodeUrl = res.data[0].captcha.img
          this.ckey = res.data[0].captcha.key
          if (this.form.imgCaptcha) this.$refs.form.validate('imgCaptcha')
        }
      })
    },
    // 提交
    onSubmit(values) {
      singleActivitySever.registrations({
        ...values,
        ckey:this.ckey,
        organizerActivityId:this.form.organizerActivityId,
      }).then(res => {
        if (res["code"] == 0) {
          this.$dialog.alert({
            title: '您已成功报名!',
            message: '请耐心等待官方的审核',
            confirmButtonColor: '#2537B5',
            confirmButtonText: '好的',
          }).then(() => {
            location.reload();
          });
        } else {
          this.$dialog.alert({
            message: res['message'],
            confirmButtonColor: '#2537B5',
          });
        }
      })
    },
  }
};
</script>

<style scoped lang="scss">
.activity-mobile {
  background-color: #000;
  color: #fff;

  .title {
    width: 120px;
    font-weight: bold;
    font-size: 24px;
    color: #E9C799;

    &:after {
      content: "";
      display: block;
      background: #ccc;
      margin-top: 7px;
      width: 50px;
      height: 6px;
      background: linear-gradient(90deg, #FAE7BD 0%, #C7A276 100%);
      border-radius: 17px 17px 17px 17px;
    }
  }

  .content-box {
    margin-top: 40px;
    padding: 0 16px 0 14px;

    .form {
      /deep/ .van-cell--required::before {
        top: 11px;
        left: 7px;
      }

      /deep/ .van-field__control {
        display: block;
        padding: 6px 8px;
        background-color: #19191B;
        font-size: 14px;
        color: #ccc;
        border-radius: 4px;
        height: 32px;
      }

      /deep/ .van-field__control::placeholder {
        color: #666666 !important;
        -webkit-text-fill-color: #666666 !important;
        font-size: 14px;
      }

      /deep/ .van-field {
        display: block;
      }

      /deep/ .van-field__label {
        display: block;
        margin-right: 0;
        margin-bottom: 10px;
        color: #ddd;
      }

      /deep/ .van-cell__value {
        margin-left: -14px;
      }

      /deep/ .van-field__error-message {
        margin-top: 5px;
      }

      /deep/ .van-cell {
        background-color: transparent;
      }

      /deep/ .van-cell::after {
        border-bottom: 0;
      }

      .radius {
        display: block;
        margin: auto;
        border: none;
        width: 160px;
        height: 40px;
        background: linear-gradient(90deg, #FAE7BD 0%, #C7A276 100%);
        border-radius: 4px;
        font-weight: 800;
        font-size: 14px;
        color: #212121;
      }

      .code-box {
        width: 100%;


        /deep/ .van-field__button {
          display: flex;
          align-items: center;
        }

        .code-img {
          width: 140px;
          height: 32px;
          border-radius: 4px;
        }
      }
    }

    .notice {
      padding: 60px 0 46px;

      .notice-content {
        font-weight: 500;
        font-size: 14px;
        color: #DDDDDD;
        line-height: 25px;
        margin-top: 18px;

        & > div {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>

